module.exports = __webpack_public_path__ + "static/media/visa.3763fafd.svg";